"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = exports.renderChildren = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const renderChildren = (children) => {
    let childrenToIterate;
    if (!Array.isArray(children)) {
        childrenToIterate = [children];
    }
    else {
        childrenToIterate = children;
    }
    return childrenToIterate.map((child, index) => {
        return (0, jsx_runtime_1.jsx)("div", { children: child }, `child_${index}`);
    });
};
exports.renderChildren = renderChildren;
const Card = (props) => ((0, jsx_runtime_1.jsxs)(Wrapper, { className: props.className, children: [(0, jsx_runtime_1.jsx)("div", { children: props.header }, void 0), (0, jsx_runtime_1.jsx)("div", { children: props.children && (0, exports.renderChildren)(props.children) }, void 0)] }, void 0));
exports.Card = Card;
const Wrapper = styled_components_1.default.div `
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  flex-direction: column;

  & > div:first-of-type {
    padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};
    width: 100%;
    min-height: 56px;
    @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
      padding: ${({ theme }) => theme.spacings.m};
    }
  }

  & > div:first-of-type > h2 {
    margin: 0;
  }

  & > div:last-of-type {
    border-top: 1px solid ${({ theme }) => theme.colors.silverBase};
    overflow: hidden;
    padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};

    @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
      padding: ${({ theme }) => theme.spacings.m};
    }
  }

  & > div:last-of-type > div:not(:last-of-type) {
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.silverLighten40};
  }

  & > div:last-of-type:empty {
    border-top: none;
    padding: 0;
  }
`;
//# sourceMappingURL=Card.js.map